import * as z from "zod";

const ppuSplitRowSchema = z.object({
  _id: z.string(),
  name: z.string(),
  active: z.boolean(),
  createdAt: z.date(),
  concludedAt: z.date().optional(),
  testDurationDays: z.number().optional(),
  totalRevenue: z.string().optional(),
  visits: z.number().optional(),
  acceptedOffers: z.number().optional(),
  conversionRate: z.string().optional(),
  revenuePerVisit: z.string().optional(),
});

export type PpuSplitRow = z.infer<typeof ppuSplitRowSchema>;

export const getPostPurchaseSplits = {
  name: "getPostPurchaseSplits" as const,
  input: z.null(),
  output: z.object({
    activeSplits: z.array(ppuSplitRowSchema),
    concludedSplits: z.array(ppuSplitRowSchema),
  }),
};
